import { IonButton, IonCol, IonRow, IonSpinner } from '@ionic/react';
import { Link, useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import Btn from '../../../components/Btn';
import { GlobalContext } from '../../../context/provider';
import classes from './styles.module.scss';
import {
  RESETPASSWORD,
  RESETPASSWORD_ERROR,
} from '../../../context/actions/types';
import { resetPassword } from '../../../context/actions/user';
import { eye } from 'ionicons/icons';
import AuthLayout from '../components/AuthLayout';
import { set } from 'date-fns';
import { RiLockPasswordFill } from 'react-icons/ri';
import ErrorToast from '../../../components/error_toast';
import InputCard, { InputCardTypes } from '../../../components/inputField';
import { IoCheckmark, IoClose } from 'react-icons/io5';

const ResetPassword: React.FC = (props: any) => {
  const history = useHistory();
  const { email, code } = props.location && props.location.state;
  const [passwordMatch, setPasswordMatch] = useState(false);
  const { userState, userDispatch } = useContext<any>(GlobalContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [match, setMatch] = useState<boolean | undefined>(false);
  const [error, setError] = useState<{
    state: boolean;
    message: string | null;
  }>({
    state: false,
    message: null,
  });
  const [validationError, setValidationError] = useState<{
    state: boolean;
    message: string | null;
  }>({
    state: false,
    message: null,
  });
  const [form, setForm] = useState<{
    password: string;
    confirm: string;
  }>({
    password: '',
    confirm: '',
  });
  let password_props: InputCardTypes = {
    borders: false,
    type: 'password',
    placeholder: 'Enter Password',
    name: 'password',
    maxLength: 32,
    minLength: 8,
    clear: false,
    inputType: 'text-field',
    required: true,
    formValues: form,
    value: setForm,
    passwordToggle: true,
  };
  let comfirm_props: InputCardTypes = {
    borders: false,
    type: 'password',
    placeholder: 'Confirm Password',
    name: 'confirm',
    maxLength: 32,
    minLength: 8,
    clear: false,
    inputType: 'text-field',
    required: true,
    formValues: form,
    value: setForm,
    icon: passwordMatch ? <IoCheckmark /> : <IoClose />,
    iconSlot: 'end',
    passwordToggle: true,
  };

  useEffect(() => {
    if (form?.password.trim().length > 0 || form?.confirm.trim().length > 0) {
      setPasswordMatch(form?.password === form?.confirm);
    }
  }, [form]);
  useEffect(() => {
    if (userState?.resetPassword) {
      const form = userState.resetPassword?.form;
      setForm(form);
      userDispatch({ type: RESETPASSWORD, payload: null });
      history.push('/reset-password-success');
    }
    if (userState.resetPasswordError) {
      setError({
        state: true,
        message: userState?.resetPasswordError?.response?.data.message,
      });
      userDispatch({ type: RESETPASSWORD_ERROR, payload: null });
    }
    setLoading(false);
  }, [userState.resetPassword, userState.resetPasswordError]);

  useEffect(() => {
    if (form?.password.trim().length > 0 || form?.confirm.trim().length > 0) {
      setMatch(true);
    } else {
      setMatch(false);
    }
  }, [form?.password, form?.confirm]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError({
      state: false,
      message: null,
    });
    if (form?.confirm !== form?.password) {
      setError({
        state: true,
        message: 'Passwords do not match',
      });
      return;
    }
    if (form.password.length < 6 || form.confirm.length < 6) {
      setValidationError({
        state: true,
        message: 'Password should be 6 characters or more',
      });
      return;
    }
    setLoading(true);
    const user = {
      password: form.password,
      code,
      email,
    };
    await resetPassword(user)(userDispatch);
  };
  return (
    <AuthLayout>
      <ErrorToast
        message={error.message!}
        isOpen={error.state}
        position={'bottom'}
        type="error"
        onClose={() => {
          setError({ state: false, message: null });
        }}
      />
      <section className="w-full h-auto flex flex-col items-center justify-center md:px-[35%] px-6">
        <div className="w-[25dvw] md:w-[8dvw] h-auto aspect-square rounded-full bg-white flex  items-center justify-center mt-4 p-8 md:p-10 overflow-hidden">
          <RiLockPasswordFill size="100%" className="text-secondary" />
        </div>
        <div className="w-full flex flex-col items-center justify-center font-roboto text-primary mt-4 py-2 text-center">
          <h2 className="text-2xl md:text-3xl font-medium ">
            Set New Password
          </h2>
          <p className="text-base font-light mt-2 ">
            Your new password should be diffrent from previously used passwords
          </p>
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          <InputCard {...password_props} />
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          <InputCard {...comfirm_props} />
        </div>

        <div className="w-full flex  items-center justify-center mt-4">
          <IonButton
            type="submit"
            onClick={handleSubmit}
            color="secondary"
            expand="block"
            fill="solid"
            className="w-full font-roboto text-base font-medium"
            disabled={!passwordMatch || loading}
          >
            {loading && <IonSpinner slot="end"></IonSpinner>}
            Submit
          </IonButton>
        </div>
        <div className="w-full flex  items-center justify-center my-4">
          <IonButton
            type="submit"
            color="primary"
            fill="clear"
            className="w-auto font-roboto text-base font-normal"
          >
            <Link to="/login" className="!text-primary !hover:text-secondary">
              Back to Login
            </Link>
          </IonButton>
        </div>
      </section>
    </AuthLayout>
  );
};

export default ResetPassword;
